<template>
    <div class="show" >
        <el-row>
            <el-col :span="12">
                <div class="grid-content bg-purple" style="margin-top:15px;margin-left:10%;margin-right:15px ">
                    <el-card shadow="always">
                        <el-form ref="item" :model="item"  label-width="100px" >
                            <el-form-item label="商品ID">
                                <el-input v-model="item.id" disabled  clearable></el-input>
                            </el-form-item>
                            <el-form-item label="品牌名称">
                                <el-input v-model="item.brand"  disabled clearable></el-input>
                            </el-form-item>
                            <el-form-item label="商品名称">
                                <el-input v-model="item.name" disabled  clearable></el-input>
                            </el-form-item>
                            <el-form-item v-if="this.item.picture||this.supplePicture">
                              <el-col  :span="this.item.supplePicture? 12:24">
                                <el-upload
                                  v-if="this.item.picture"
                                  disabled
                                  class="avatar-uploader"
                                  action="http://localhost:7777/goods/upload"
                                  :show-file-list="false"
                                  :on-success="handleAvatarSuccess"
                                  :before-upload="beforePictureUpload">
                                  <img v-if="this.item.picture" :src="this.item.picture" class="avatar">
                                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                  <div class="el-upload__tip" slot="tip">到样图</div>
                                </el-upload>
                              </el-col>
                              <el-col  :span="this.item.picture? 12:24">
                                <el-upload v-if="this.item.supplePicture"
                                  disabled
                                  class="avatar-uploader"
                                  action="1111"
                                  :show-file-list="false"
                                  :before-upload="beforeSupplePictureUpload">
                                  <img v-if="this.item.supplePicture" :src="this.item.supplePicture" class="avatar">
                                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                  <div class="el-upload__tip" slot="tip">补样图</div>
                                </el-upload>
                              </el-col>
                            </el-form-item>
                            <el-form-item label="商品属性" v-if="this.item.properties">
                                <el-input v-model="item.properties"   clearable></el-input>
                            </el-form-item>
                            <el-form-item label="所属店铺" v-if="this.item.shop">
                                <el-input v-model="item.shop"   clearable></el-input>
                            </el-form-item>
                            <el-form-item label="商品位置" v-if="this.item.location">
                                <el-input v-model="item.location"   clearable></el-input>
                            </el-form-item>
                            <el-form-item label="商品描述" v-if="this.item.description">
                                <el-input type="textarea"     v-model="item.description" :maxlength=textMaxLenth autosize> </el-input>
                            </el-form-item>
                            <el-form-item label="商品日常价格" v-if="this.item.highPrice || this.item.lowPrice">
                              <el-col :span="10">
                                <el-input v-model="item.highPrice"   clearable>
                                </el-input>
                              </el-col>
                              <el-col class="line" :span="4">直播价</el-col>
                              <el-col :span="10">
                                <el-input v-model="item.lowPrice"     clearable></el-input>
                              </el-col>
                            </el-form-item >
                            <el-form-item label="到样时间" v-if="this.item.arrivalTime">
                                <el-date-picker v-model="item.arrivalTime" type="date"  style="width:100%"> </el-date-picker>
                            </el-form-item>
                            <el-form-item label="到样总数" v-if="this.item.num">
                                <el-input type="textarea" placeholder="请输入内容" v-model="item.num" :maxlength=textMaxLenth autosize> </el-input>
                            </el-form-item>
                            <el-form-item label="型号/规格" v-if="this.item.specs">
                                <el-input v-model="item.specs"   clearable></el-input>
                            </el-form-item>
                            <el-form-item label="材质/香型">
                                <el-input type="textarea" placeholder="请输入材质信息" v-model="item.material" :maxlength=textMaxLenth autosize> </el-input>
                            </el-form-item>
                            <el-form-item label="颜色/口味">
                                <el-input type="textarea" placeholder="请输入内容" v-model="item.color" :maxlength=textMaxLenth autosize> </el-input>
                            </el-form-item>
                            <el-form-item label="到期时间" v-if="this.item.exp">
                                <el-date-picker v-model="item.exp" type="date" placeholder="选择过期日期" style="width:100%"> </el-date-picker>
                            </el-form-item>
                            <el-form-item label="赠品" v-if="this.item.gifts">
                              <el-input type="textarea" v-model="item.gifts"  :maxlength=textMaxLenth autosize> </el-input>
                            </el-form-item>
                            <el-form-item label="通过试样" >
                              <el-col :span="4">
                                <el-switch v-model="item.pass" ></el-switch>
                              </el-col>
                              <el-col class="line" :span="2">备注</el-col>
                              <el-col :span="18">
                                <el-input type="textarea"    v-model="item.tryDetails" :maxlength=textMaxLenth autosize> </el-input>
                              </el-col>
                            </el-form-item>
                            <!-- <el-form-item label="排期">
                                <el-col :span="11">
                                  <el-date-picker type="date"    v-model="item.scheduledFrom" style="width: 100%;"></el-date-picker>
                                </el-col>
                                <el-col class="line" :span="2">-</el-col>
                                <el-col :span="11">
                                  <el-date-picker type="date"    v-model="item.scheduledTo" style="width: 100%;"></el-date-picker>
                                </el-col>
                            </el-form-item> -->
                            <el-form-item label="已经拥有" v-if="item.has.length > 0">
                              {{item.has.join(' · ')}}
                                <!-- <el-checkbox-group   v-model="item.has">
                                    <el-checkbox label="卖点卡" name="sellingPointCards"></el-checkbox>
                                    <el-checkbox label="商家卖点卡" name="merchantSellingPointCards"></el-checkbox>
                                    <el-checkbox label="比价图" name="PriceComparisonChart"></el-checkbox>
                                    <el-checkbox label="辅助文件" name="auxiliaryFiles"></el-checkbox>
                                </el-checkbox-group> -->
                            </el-form-item>
                            <el-form-item label="附件" v-if="this.item.fileList.length > 0">
                                <el-link  v-for="(file, i) in item.fileList" :key="(i+1)" :href="file.url" target="_blank" style="width: 100%;">{{file.name}}</el-link>
                            </el-form-item>
                        </el-form>
                    </el-card>
                </div>
            </el-col>

            <el-col :span="12">
                <div class="grid-content bg-purple" style="margin-top:15px;margin-left:10%;margin-right:10% ">
                    <el-row>
                        <el-card shadow="always">
                          <el-divider v-if="this.item.suppleTime || this.item.suppleNum || this.item.suppleDetails">补样</el-divider>
                            <el-form ref="item" :model="item" label-width="80px" >
                                <el-form-item label="补样时间" v-if="this.item.suppleTime" style="margin-top:7%">
                                    <el-date-picker v-model="item.suppleTime"  type="date"  style="width:100%"> </el-date-picker>
                                </el-form-item>
                                <el-form-item label="补样数量" v-if="this.item.suppleNum">
                                  <el-input type="textarea" placeholder="请输入内容" v-model="item.suppleNum" :maxlength=textMaxLenth autosize> </el-input>
                                </el-form-item>
                                <el-form-item label="备注" v-if="this.item.suppleDetails" style="margin-bottom:7%">
                                    <el-input type="textarea"    v-model="item.suppleDetails" :maxlength=textMaxLenth autosize> </el-input>
                                </el-form-item>
                                <!-- <el-divider v-if="this.item.returnTime || this.item.returnAddress || this.item.returnNumber || this.item.returnDetails || this.item.returnFileList.length > 0 ">退样</el-divider> -->
                                <el-divider v-if="this.item.returnTime || this.item.returnAddress || this.item.returnNumber || this.item.returnDetails || this.item.returnFileList.length > 0 ">退样</el-divider>
                                <el-form-item label="退样时间" v-if="this.item.returnTime" style="margin-top:7%">
                                    <el-date-picker v-model="item.returnTime" type="date"   style="width:100%"> </el-date-picker>
                                </el-form-item>
                                <el-form-item label="退样地址" v-if="this.item.returnAddress">
                                    <el-input v-model="item.returnAddress"   clearable></el-input>
                                </el-form-item>
                                <el-form-item label="退样单号" v-if="this.item.returnNumber">
                                    <el-input v-model="item.returnNumber"   clearable></el-input>
                                </el-form-item>
                                <el-form-item label="备注" v-if="this.item.returnDetails">
                                    <el-input type="textarea"   v-model="item.returnDetails" :maxlength=textMaxLenth autosize> </el-input>
                                </el-form-item>
                                <el-form-item label="退样图片" v-if="this.item.returnFileList.length > 0" style="margin-bottom:7%">
                                    <el-link  v-for="(file, i) in item.returnFileList" :key="(i+1)" :href="file.url" target="_blank" style="width: 100%;">{{file.name}}</el-link>
                                </el-form-item>

                                <div style="margin-top:5%">
                                  <el-divider>商品详情</el-divider>
                                  <el-row>
                                  <!-- <el-form-item> -->
                                    <el-col class="line" :span="3">是否退样</el-col>
                                    <el-col  :span="3">
                                      <el-switch v-model="item.isReturned"></el-switch>
                                    </el-col>
                                    <!-- <el-col  :span="6">&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;</el-col> -->
                                    <el-col class="line" :span="3" >是否过期</el-col>
                                    <el-col  :span="3">
                                      <el-switch v-model="item.isExpired"></el-switch>
                                    </el-col>
                                    <el-col class="line" :span="3" >是否补样</el-col>
                                    <el-col  :span="3">
                                      <el-switch v-model="item.isSupply"></el-switch>
                                    </el-col>
                                    <el-col class="line" :span="3" >是否报损</el-col>
                                    <el-col  :span="3">
                                      <el-switch v-model="item.isReportLosses"></el-switch>
                                    </el-col>
                                  </el-row>
                                  <!-- </el-form-item> -->
                                  <!-- <el-form-item label="是否过期">
                                    <el-col :span="4">
                                    <el-switch v-model="item.isExpired"></el-switch>
                                  </el-col>
                                  </el-form-item> -->
                                </div>

                                <el-divider v-if="this.inventoryHis.length > 0">盘货记录</el-divider>
                                <div style="margin-top:3%">
                                  <el-table :data="inventoryHis" stripe style="width: 100%" max-height="800px">
                                    <el-table-column prop="time" label="时间" width="200PX"> </el-table-column>
                                    <el-table-column prop="details" label="备注"> </el-table-column>
                                  </el-table>
                                </div>

                                <el-divider v-if="this.item.history.length > 0">直播记录</el-divider>
                                <el-table v-if="this.item.history.length > 0"
                                    :data="item.history"
                                    stripe
                                    style="width: 100%;margin-top:7%"
                                    max-height="800px">
                                    <el-table-column
                                    prop="date"
                                    label="历史直播记录">
                                    </el-table-column>
                                </el-table>
                            </el-form>
                        </el-card>
                    </el-row>
                </div>
            </el-col>
            <!-- <el-col :span="12">
                <div class="grid-content bg-purple" style="margin-top:15px;margin-left:10%;margin-right:10% ">
                    <el-row>
                        <el-card shadow="always">
                            <el-form ref="item" :model="item" label-width="80px" >
                                <el-form-item label="补样时间" >
                                    <el-date-picker v-model="item.suppleTime"  type="date"  style="width:100%"> </el-date-picker>
                                </el-form-item>
                                <el-form-item label="补样数量" >
                                  <el-input type="textarea"  v-model="item.suppleNum" :maxlength=textMaxLenth autosize> </el-input>
                                </el-form-item>
                                <el-form-item label="备注" >
                                    <el-input type="textarea"    v-model="item.suppleDetails" :maxlength=textMaxLenth autosize> </el-input>
                                </el-form-item>
                                <el-divider ></el-divider>
                                <el-form-item label="退样时间" >
                                    <el-date-picker v-model="item.returnTime" type="date"   style="width:100%"> </el-date-picker>
                                </el-form-item>
                                <el-form-item label="退样地址" >
                                    <el-input v-model="item.returnAddress"   clearable></el-input>
                                </el-form-item>
                                <el-form-item label="退样单号" >
                                    <el-input v-model="item.returnNumber"   clearable></el-input>
                                </el-form-item>
                                <el-form-item label="备注" >
                                    <el-input type="textarea"   v-model="item.returnDetails" :maxlength=textMaxLenth autosize> </el-input>
                                </el-form-item>
                                <el-form-item label="退样图片" >
                                    <el-link  v-for="(file, i) in item.returnFileList" :key="(i+1)" :href="file.url" target="_blank" style="width: 100%;">{{file.name}}</el-link>
                                </el-form-item>
                                <el-divider v-if="this.item.history.length > 0"></el-divider>
                                <el-table v-if="this.item.history.length > 0"
                                    :data="item.history"
                                    stripe
                                    style="width: 100%">
                                    <el-table-column
                                    prop="date"
                                    label="历史直播记录">
                                    </el-table-column>
                                    </el-table>
                            </el-form>
                        </el-card>
                    </el-row>
                </div>
            </el-col> -->
        </el-row>
    </div>
</template>

<script>
import Common from './Common'
export default {
  name: 'Show',
  data () {
    return {
      item: {
        id: this.$route.query.id,
        brand: '',
        name: '',
        picture: '',
        supplePicture: '',
        shop: '',
        location: '',
        properties: '',
        highPrice: '',
        lowPrice: '',
        exp: '',
        gifts: '',
        description: '',
        arrivalTime: '',
        num: '',
        specs: '',
        material: '',
        color: '',
        tryDetails: '',
        pass: true,
        scheduledFrom: '',
        scheduledTo: '',
        has: [],
        suppleTime: '',
        suppleNum: '',
        suppleDetails: '',

        returnFileList: [],
        returnTime: '',
        returnAddress: '',
        returnNumber: '',
        returnDetails: '',
        fileList: [],
        history: [],
        isReturned: false,
        isExpired: false,
        isSupply: false,
        isReportLosses: false
      },
      textMaxLenth: 300,
      inventoryHis: []
    }
  },
  mounted () {
    this.getItemById()
    this.getInventoryHis()
  },
  methods: {
    getItemById () {
      this.$axios.get(Common.baseUrl + 'goods/getById', {params: {id: this.$route.query.id}}
      ).then((res) => {
        let code = res.data.code
        if (code === 200) {
          this.item = res.data.data
          if (this.item.pass === 'true') {
            this.item.pass = true
          }
          if (this.item.isExpired === 'true') {
            this.item.isExpired = true
          }
          if (this.item.isReturned === 'true') {
            this.item.isReturned = true
          }
          if (this.item.isSupply === 'true') {
            this.item.isSupply = true
          }
          if (this.item.isReportLosses === 'true') {
            this.item.isReportLosses = true
          }
          console.log(this.item.fileList)
        } else if (code === 401) {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
          this.$router.push('/login')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch(error => {
        this.$message({
          message: error,
          type: 'warning'
        })
      })
    },
    getInventoryHis () {
      this.$axios.get(Common.baseUrl + 'inventoryHasGoods/getInventoryHis', {params: {goodsId: this.item.id}}
      ).then((res) => {
        let code = res.data.code
        if (code === 200) {
          this.inventoryHis = res.data.data
        } else if (code === 401) {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
          this.$router.push('/login')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch(error => {
        this.$message({
          message: error,
          type: 'warning'
        })
      })
    }
  }
}
</script>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    /* width: 100%;
    height: 100%; */
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/Show.vue